/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    styleId: 1,
  },
  {
    styleId: 2,
    shareBtnConfig: {
      btnSize: {
        heightVal: 53,
        widthVal: 52
      },
      btnText: {
        fontSize: 12,
        lineHeight: 17,
      },
      btnTextActive: {
        fontSize: 12,
        lineHeight: 17,
      }
    },
    itemList: [
      {
        id: 0,
        iconSrc: "https://p.cldisk.com/star3/origin/29fadbec1de7c54f5f256dece14e20a3.png?rw=64&rh=64&_fileSize=1066&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "微信"
      },{
        id: 1,
        iconSrc: "https://p.cldisk.com/star3/origin/a0bc6fd754f0bb4b7567bb25ee017393.png?rw=64&rh=64&_fileSize=1898&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "微博"
      },{
        id: 2,
        iconSrc: "https://p.cldisk.com/star3/origin/deb419f5300bcdc76ca516534961febe.png?rw=64&rh=64&_fileSize=1467&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "QQ"
      },{
        id: 3,
        iconSrc: "https://p.cldisk.com/star3/origin/7d8dc2edfbb0d9ae1146cac530f4c33b.png?rw=64&rh=64&_fileSize=1198&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "QQ空间"
      },{
        id: 4,
        iconSrc: "https://p.cldisk.com/star3/origin/71247c55ab39300f4719100435731e2e.png?rw=64&rh=64&_fileSize=1275&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "复制链接"
      }
    ]
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [{}]

/**
 * app状态标签默认配置数据
 */
export const appHome = [
  {
    styleId: 1,
  },
  {
    styleId: 2,
    shareBtnConfig: {
      btnSize: {
        heightVal: 53,
        widthVal: 52
      },
      btnText: {
        fontSize: 12,
        lineHeight: 17,
      },
      btnTextActive: {
        fontSize: 12,
        lineHeight: 17,
      }
    },
    itemList: [
      {
        id: 0,
        iconSrc: "https://p.cldisk.com/star3/origin/29fadbec1de7c54f5f256dece14e20a3.png?rw=64&rh=64&_fileSize=1066&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "微信"
      },{
        id: 1,
        iconSrc: "https://p.cldisk.com/star3/origin/a0bc6fd754f0bb4b7567bb25ee017393.png?rw=64&rh=64&_fileSize=1898&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "微博"
      },{
        id: 2,
        iconSrc: "https://p.cldisk.com/star3/origin/deb419f5300bcdc76ca516534961febe.png?rw=64&rh=64&_fileSize=1467&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "QQ"
      },{
        id: 3,
        iconSrc: "https://p.cldisk.com/star3/origin/7d8dc2edfbb0d9ae1146cac530f4c33b.png?rw=64&rh=64&_fileSize=1198&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "QQ空间"
      },{
        id: 4,
        iconSrc: "https://p.cldisk.com/star3/origin/71247c55ab39300f4719100435731e2e.png?rw=64&rh=64&_fileSize=1275&_orientation=1",
        iconType: "img",
        isShow: true,
        name: "复制链接"
      }
    ]
  }
]
